// config.js
const config = {
    // backendUrl: 'http://192.10.250.112:5001', 
    // backendUrl: "https://dilipsindiaapi.stellifyflows.in", 
      backendUrl: "https://loyalityapi.dilipsindia.com",

  };
  
  export default config;
  